import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "./../components/child/Alert/SuccessAlert";
import Loader from "./../components/child/Loder";
const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [loading, setLoading] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const [permissions, setPermissions] = useState([]);
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const userRole =
    localStorage.getItem("user_role") === "super_admin"
      ? "Super Admin"
      : "Sub Admin";

  const role = localStorage.getItem("user_role");
  const adminid = localStorage.getItem("admin_id");
  useEffect(() => {
    const fetchAdminData = async () => {
      if (!adminid) return;

      setLoading(false);
      try {
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminById/${adminid}`;
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch admin data");

        const data = await response.json();

        setStatus(data.result.status);
        if (data.result.deletedAt != null) {
          localStorage.removeItem("authToken");
          localStorage.removeItem("admin_id");
          localStorage.removeItem("user_role");
          localStorage.removeItem("permissions");
          localStorage.removeItem("profile_picture");
          localStorage.removeItem("name");
          sessionStorage.clear();

          setSuccessMessage(
            "You have been signed out because your profile has been deleted by the admin. Please contact the admin to sign in again."
          );
          setTimeout(() => {
            setLoading(false);
            setSuccessMessage("");
            navigate("/sign-in");
          }, 1000);
        }
        if (data.result.status === "inactive") {
          localStorage.removeItem("authToken");
          localStorage.removeItem("admin_id");
          localStorage.removeItem("user_role");
          localStorage.removeItem("permissions");
          localStorage.removeItem("profile_picture");
          localStorage.removeItem("name");
          sessionStorage.clear();

          setSuccessMessage(
            "You have been signed out because your profile has been deactivated by the admin. Please contact the admin to sign in again."
          );
          setTimeout(() => {
            setLoading(false);
            setSuccessMessage("");
            navigate("/sign-in");
          }, 1000);
        }
        let parsedPermissions = [];
        if (typeof data.result.permissions === "string") {
          parsedPermissions = JSON.parse(data.result.permissions);
        } else if (
          typeof data.result.permissions === "object" &&
          data.result.permissions !== null
        ) {
          parsedPermissions = data.result.permissions;
        }
        setPermissions(parsedPermissions);
        localStorage.setItem("permissions", JSON.stringify(parsedPermissions));
      } catch (err) {
        console.error("Error fetching admin data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [adminid]);

  useEffect(() => {
    try {
      const storedPermissions = JSON.parse(
        localStorage.getItem("permissions") || "[]"
      );

      setPermissions(storedPermissions);
    } catch (err) {
      console.error("Error parsing permissions from localStorage:", err);
    }
  }, []);

  const filteredPermissions = permissions.filter(
    (perm) => perm.add || perm.edit || perm.view || perm.delete
  );

  const moduleIcons = {
    Dashboard: "solar:home-smile-angle-outline",
    User: "flowbite:users-group-outline",
    Host: "flowbite:users-group-outline",
    categories: "mdi:aspect-ratio",
    facilities:"mdi:office-building-outline",
    cms: "octicon:info-24",
    faq: "mage:message-question-mark-round",
    help: "mage:message-question-mark-round",
    club:"mdi:office-building-outline",
    setting:"material-symbols:settings",
    discount:"mdi:percent-box",
    review:"mdi:star-box",
    booking:"mdi:book-account" ,
    payment:"mdi:credit-card-outline",
     notification: "mdi:bell",
    webuser:"mdi:human-greeting-proximity"
  };
  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/sign-in"); // Redirect if already logged in
    }
    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname, navigate]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const handleLogout = () => {
    setLoading(true);
    localStorage.removeItem("authToken");
    localStorage.removeItem("admin_id");
    localStorage.removeItem("user_role");
    localStorage.removeItem("permissions");
    localStorage.removeItem("profile_picture");
    localStorage.removeItem("name");
    sessionStorage.clear();
    setSuccessMessage("You have Sign out successfully!! Redirecting...");
    setTimeout(() => {
      setLoading(false);
      setSuccessMessage("");
      navigate("/sign-in");
    }, 3000);
  };

  if (loading) {
    //alert(loading);
    if (loading) return <Loader />;
  }
  const basePath = "/vr-admin";
  const path = "dashboard";
  const isActive = location.pathname.startsWith(`/${path}`);
  //s alert(location.pathname.startsWith(`/${path}`));
  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link
            to={isActive ? `/dashboard` : "/dashboard"}
            className="sidebar-logo"
            onClick={(e) => e.preventDefault()}
            style={{ cursor: "auto" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
              alt="site logo"
              className="light-logo"
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo-light.png`}
              alt="site logo"
              className="dark-logo"
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu">
            <li>
              <li>
                {isActive ? (
                  <a href={`/dashboard`} className="active-page">
                 {/* <a href={`${basePath}/dashboard`} className="active-page"> */}
                    <Icon
                      icon="solar:home-smile-angle-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </a>
                ) : (
                  <Link to={`/dashboard`} className="">
                    <Icon
                      icon="solar:home-smile-angle-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </Link>
                )}
              </li>
            </li>

            {role === "super_admin" ? (
              <>
                {["user","host","categories","club","discount","review","booking","payment","help","webuser","setting","cms","notification"].map((path) => {
                  const isActive = location.pathname.startsWith(`/${path}`);

                  const label =
                    path === "user"
                      ? "User Management"
                       :path === "host"
                      ? "Host Management"
                      : path === "categories"
                      ? "Categories"
                      : path === "facilities"
                      ? "Facilities"
                      : path === "cms"
                      ? "CMS"
                       : path === "club"
                      ? "Club Management"
                      : path === "help"
                      ? "Help & Support"
                       : path === "discount"
                      ? "Discount Management"
                       : path === "review"
                      ? "Review Management"
                       : path === "booking"
                      ? "Booking Management"
                       : path === "payment"
                      ? "Payment History"
                      : path === "webuser"
                      ? "Get In Touch"
                      : path
                          .replace(/-/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase());
                  return (
                    <li key={path}>
                      {isActive ? (
                      <a href={`/${path}`} className="active-page">
                        {/* <a href={`${basePath}/${path}`} className="active-page"> */}
                          <Icon
                            icon={
                              moduleIcons[path] ||
                              "flowbite:users-group-outline"
                            }
                            className="menu-icon"
                          />
                          <span>{label}</span>
                        </a>
                      ) : (
                        <Link to={`/${path}`}>
                          <Icon
                            icon={
                              moduleIcons[path] ||
                              "flowbite:users-group-outline"
                            }
                            className="menu-icon"
                          />
                          <span>{label}</span>
                        </Link>
                      )}
                    </li>
                  );
                })}
              </>
            ) : (
              filteredPermissions.map((perm) => {
                const path = perm.moduleName.toLowerCase().replace(/\s+/g, "-");
                const isActive = location.pathname.startsWith(`/${path}`);
                const label =
                  perm.moduleName === "Space Type"
                    ? "Storage Type"
                    : perm.moduleName;
                const basePath = "/vr-admin";
                return (
                  <li key={perm.moduleName}>
                    {isActive ? (
                      <a href={`/${path}`} className="active-page">
                         {/* <a href={`${basePath}/${path}`} className="active-page"> */}
                        <Icon
                          icon={
                            moduleIcons[path] || "flowbite:users-group-outline"
                          }
                          className="menu-icon"
                        />
                        <span>{label}</span>
                      </a>
                    ) : (
                      <Link to={`/${path}`}>
                        <Icon
                          icon={
                            moduleIcons[path] || "flowbite:users-group-outline"
                          }
                          className="menu-icon"
                        />
                        <span>{label}</span>
                      </Link>
                    )}
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* <div className="dropdown">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Icon
                      icon="iconoir:bell"
                      className="text-primary-light text-xl"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                    <div className="m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-0">
                          Notifications
                        </h6>
                      </div>
                      <span className="text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center">
                        0
                      </span>
                    </div>
                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-4">
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                         
                          <div>
                           
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              No data found
                            </p>
                          </div>
                        </div>
                        
                      </Link>
                     
                    </div>
                  
                  </div>
                </div> */}
                {/* Notification dropdown end */}
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={localStorage.getItem("profile_picture")}
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {localStorage.getItem("name")}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          {userRole}
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/view-profile"
                        >
                          <Icon
                            icon="solar:user-linear"
                            className="icon text-xl"
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          to="#"
                          onClick={handleLogout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Sign Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2025 Vibes Reserve</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Developed by{" "}
                <a
                  href="https://www.iqlance.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-primary-600">iQlance Solution</span>
                </a>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
